import { useEffect, useState } from 'react';
import { ThemeClient } from '../contexts/Theme';
import Navbar from '../Navbar';
import ResponsiveGallery from 'react-responsive-gallery';
import { supabase, host } from '../supabaseClient';

import { useCode } from '../contexts/Code';
import { useCompany } from '../contexts/Company';
import Navegation from '../components/Navegation'
import UploadPhoto from '../components/gallery/UploadPhoto'

export default function Gallery() {
  const [galleryItems, setGalleryItems] = useState([]);
  const [title, setTitle] = useState('');
  const { code } = useCode();
  const company = useCompany();

  const getGallery = async () => {
    const { data, error } = await supabase.storage.from('photos').list(code, {
      limit: 1000,
      offset: 0,
    });

    if (error) return console.log(error);

    const prefix = host + '/storage/v1/object/public/photos/' + code + '/';
    const urls = data.map((item) => prefix + item.name);

    const galleryItems = urls.map((image, index) => ({
      src: image,
      alt: `image ${index + 1} alt test`,
    }));

    setGalleryItems(galleryItems);
  };

  useEffect(() => {
    getGallery();
  }, []);

  useEffect(() => {
    if (company?.id == 45) {
      setTitle('Gallery');
    } else {
      setTitle('Galería');
    }
  }, [company]);

  return (
    <ThemeClient>
      <Navbar title={title} />

      <UploadPhoto onUpload={(e)=> getGallery()}/>

      <ResponsiveGallery
        numOfImagesPerRow={{ xs: 2, s: 2, m: 3, l: 3, xl: 4, xxl: 5 }}
        customLoader={<></>}
        useLightBox
        images={galleryItems}
        customError={<></>}
      />
      <Navegation/>
    </ThemeClient>
  );
}